import { createSlice } from "@reduxjs/toolkit";

const documentSlice = createSlice({
  name: "documents",
  initialState: {
    documentIds: [],
  },
  reducers: {
    addDocumentId: (state, action) => {
      state.documentIds.push(action.payload); // Add document ID
    },
    removeDocumentId: (state, action) => {
      state.documentIds = state.documentIds.filter((id) => id !== action.payload); // Remove document ID
    },
    resetDocumentId: (state) => {
      state.documentIds = []; // Reset state to an empty array
    },
  },
});

export const { addDocumentId, removeDocumentId,resetDocumentId } = documentSlice.actions;

export default documentSlice.reducer;
